import React, { useState, useEffect } from "react";
import axios from "axios";
import Swal from "sweetalert2";
import { 
  HiOutlinePhone, HiOutlineCurrencyRupee, HiOutlineShieldCheck, 
  HiChevronRight, HiOutlineLightningBolt, HiOutlineBadgeCheck,
  HiOutlineSupport, HiOutlineClock
} from "react-icons/hi";
import { BiWallet, BiRefresh, BiCheckShield } from "react-icons/bi";
import { baseurl } from "../../baseurl";
import "../../asset/css/recharge.css"; 

import airtel from "../../asset/img/airtel.png";
import vi from "../../asset/img/vi.jpg";
import bsnl from "../../asset/img/bsnl.jpg";
import jio from "../../asset/img/jio.png";

const MobileRecharge = () => {
  const [mobileNumber, setMobileNumber] = useState("");
  const [operator, setOperator] = useState("");
  const [amount, setAmount] = useState("");
  const [loading, setLoading] = useState(false);
  const [walletBalance, setWalletBalance] = useState(0);
  const SERVICE_TAX = 1;
  const guestUserId = localStorage.getItem('guestUserId');

  const operators = [
    { id: 1, name: "Airtel", logo: airtel, color: "#E11900" },
    { id: 2, name: "VI", logo: vi , color: "#F00000" },
    { id: 8, name: "BSNL", logo: bsnl, color: "#0066B3" },
    { id: 88, name: "Jio", logo: jio, color: "#0056A6" },
  ];

  const fetchBalance = () => {
    if (guestUserId) {
      axios.get(`${baseurl}/getWalletBalance/${guestUserId}`)
        .then(res => setWalletBalance(parseFloat(res.data.balance) || 0))
        .catch(err => console.error("Wallet Error", err));
    }
  };

  useEffect(() => {
    fetchBalance();
  }, [guestUserId]);

  const handleRecharge = async (e) => {
    if (e) e.preventDefault();
    const rechargeAmount = parseFloat(amount);
    const totalAmount = rechargeAmount + SERVICE_TAX;

    if (mobileNumber.length !== 10) {
      return Swal.fire({ icon: 'error', title: 'Invalid Number', text: 'Enter 10-digit mobile number' });
    }
    if (!operator || !amount) {
      return Swal.fire({ icon: 'warning', title: 'Required', text: 'Select operator and amount' });
    }
    if (walletBalance < totalAmount) {
      return Swal.fire({
        icon: 'error',
        title: 'Insufficient Balance',
        html: `Recharge: ₹${rechargeAmount}<br/>Fee: ₹${SERVICE_TAX}<br/><b>Total needed: ₹${totalAmount}</b>`,
        confirmButtonText: 'Add Money',
      }).then((res) => { if (res.isConfirmed) window.location.href = "/wallet"; });
    }

    const confirmation = await Swal.fire({
      title: 'Confirm Recharge',
      html: `<div style="text-align: left; background: #f8f9fa; padding: 15px; border-radius: 10px;">
          <p><b>Mobile:</b> +91 ${mobileNumber}</p>
          <p><b>Operator ID:</b> ${operator}</p>
          <p><b>Plan Amount:</b> ₹${rechargeAmount}</p>
          <p><b>Platform Fee:</b> ₹${SERVICE_TAX}</p>
          <hr/>
          <p style="color: #0d6efd; font-size: 1.1rem;"><b>Total: ₹${totalAmount}</b></p>
        </div>`,
      showCancelButton: true,
      confirmButtonText: 'Pay Now'
    });

    if (!confirmation.isConfirmed) return;

    setLoading(true);
    try {
      const res = await axios.post(`${baseurl}/rechargeMobileGuest`, {
        mobile_number: mobileNumber,
        provider_id: operator,
        amount: rechargeAmount,
        serviceTax: SERVICE_TAX,
        userId: guestUserId,
      });
      
      if (res.data.status === "success") {
        await Swal.fire({ icon: 'success', title: 'Success!', text: 'Recharge initiated successfully' });
        window.location.reload();
      } else {
        throw new Error(res.data.message || "Failed");
      }
    } catch (err) {
      Swal.fire({ icon: 'error', title: 'Failed', text: err.response?.data?.message || err.message });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="recharge-wrapper"  style={{marginTop: "100px"}}>
      <div className="container py-5">
        <div className="row g-4 justify-content-center">
          
          {/* --- LEFT COLUMN: FORM --- */}
          <div className="col-12 col-md-6 col-lg-5">
            {/* Wallet Card */}
            <div className="modern-wallet-card mb-4">
              <div className="wallet-content">
                <div className="d-flex justify-content-between">
                  <div>
                    <span className="wallet-label">Wallet Balance</span>
                    <h2 className="wallet-amount">₹{walletBalance.toLocaleString('en-IN')}</h2>
                  </div>
                  <div>
                    <button className="btn-primary" onClick={fetchBalance}><BiRefresh size={24} /></button>
                  </div>
                  
                </div>
                <div className="d-flex justify-content-between align-items-center mt-3">
                  <div className="wallet-chip"></div>
                  <button className="add-money-btn" onClick={() => window.location.href = "/wallet"}>Recharge Wallet</button>
                </div>
              </div>
            </div>

            {/* Recharge Form */}
            <div className="main-recharge-card shadow-lg">
              <div className="card-header-gradient p-3 text-white">
                <h5 className="mb-0 fw-bold"><HiOutlineLightningBolt className="me-2" />Instant Recharge</h5>
              </div>

              <div className="card-body p-4">
                <form onSubmit={handleRecharge}>
                  <div className="custom-input-group mb-4">
                    <label className="fw-bold small mb-1">Mobile Number</label>
                    <div className="input-wrapper">
                      <span className="prefix">+91</span>
                      <input 
                        type="number" 
                        placeholder="Enter 10 digit number"
                        value={mobileNumber}
                        onChange={(e) => setMobileNumber(e.target.value.slice(0, 10))}
                      />
                      <HiOutlinePhone className="input-icon" />
                    </div>
                  </div>

                  <div className="mb-4">
                    <label className="fw-bold small mb-2">Select Operator</label>
                    <div className="operator-grid">
                      {operators.map((op) => (
                        <div 
                          key={op.id}
                          className={`op-chip ${operator === op.id ? 'active' : ''}`}
                          onClick={() => setOperator(op.id)}
                        >
                          <div className="op-logo-bg"><img src={op.logo} alt={op.name} /></div>
                          <span>{op.name}</span>
                        </div>
                      ))}
                    </div>
                  </div>

                  <div className="custom-input-group mb-4">
                    <label className="fw-bold small mb-1">Enter Amount</label>
                    <div className="input-wrapper">
                      <span className="prefix">₹</span>
                      <input 
                        type="number" 
                        placeholder="0.00"
                        value={amount}
                        onChange={(e) => setAmount(e.target.value)}
                      />
                      <HiOutlineCurrencyRupee className="input-icon" />
                    </div>
                  </div>

                  <button type="submit" className={`recharge-submit-btn w-100 ${loading ? 'loading' : ''}`} disabled={loading}>
                    {loading ? <span className="spinner-border spinner-border-sm"></span> : <>Pay ₹{amount ? parseFloat(amount) + SERVICE_TAX : '0'} Now <HiChevronRight /></>}
                  </button>
                </form>
              </div>
            </div>
          </div>

          {/* --- RIGHT COLUMN: CONTENT & INFO --- */}
          <div className="col-12 col-md-6 col-lg-6">
            <div className="info-side-panel ps-md-4">
              <div className="mb-5">
                <h3 className="fw-bold text-dark mb-3">Why Recharge with Us?</h3>
                <p className="text-muted">Experience the fastest mobile recharge service with secure payments and instant confirmation.</p>
                
                <div className="row g-3 mt-2">
                  <div className="col-6">
                    <div className="feature-box">
                      <HiOutlineBadgeCheck className="text-primary mb-2" size={28} />
                      <h6>Instant Success</h6>
                      <p className="small text-muted">99.9% uptime for all operators.</p>
                    </div>
                  </div>
                  <div className="col-6">
                    <div className="feature-box">
                      <HiOutlineShieldCheck className="text-success mb-2" size={28} />
                      <h6>Secure Pay</h6>
                      <p className="small text-muted">Bank-grade encrypted security.</p>
                    </div>
                  </div>
                </div>
              </div>

              {/* How it Works Section */}
              <div className="recharge-steps mb-5">
                <h5 className="fw-bold mb-4">3 Simple Steps</h5>
                <div className="step-item d-flex mb-3">
                  <div className="step-num me-3">1</div>
                  <div>
                    <h6 className="mb-0">Enter Details</h6>
                    <p className="small text-muted">Enter mobile number and select operator.</p>
                  </div>
                </div>
                <div className="step-item d-flex mb-3">
                  <div className="step-num me-3">2</div>
                  <div>
                    <h6 className="mb-0">Pick a Plan</h6>
                    <p className="small text-muted">Enter the amount for your specific recharge plan.</p>
                  </div>
                </div>
                <div className="step-item d-flex mb-3">
                  <div className="step-num me-3">3</div>
                  <div>
                    <h6 className="mb-0">Instant Credit</h6>
                    <p className="small text-muted">Your talktime/data is credited immediately.</p>
                  </div>
                </div>
              </div>

              {/* Recent Offers / Promo */}
              <div className="promo-banner p-4 rounded-4 bg-primary text-white position-relative overflow-hidden">
                <div className="position-relative z-index-1">
                  <h5 className="fw-bold">Special Cashback!</h5>
                  <p className="mb-0 small opacity-75">Get up to ₹50 cashback on recharges above ₹500 using wallet balance.</p>
                </div>
                <HiOutlineCurrencyRupee className="promo-icon-bg" />
              </div>

              <div className="d-flex align-items-center justify-content-center gap-4 mt-5 opacity-50">
                <div className="text-center"><HiOutlineSupport size={20}/><div className="small">24/7 Help</div></div>
                <div className="text-center"><HiOutlineClock size={20}/><div className="small">Instant</div></div>
                <div className="text-center"><BiCheckShield size={20}/><div className="small">Verified</div></div>
              </div>
            </div>
          </div>

        </div>
      </div>

      <style>{`
        .recharge-wrapper { background: #fdfdfd; min-height: 100vh; }
        .feature-box { background: white; padding: 20px; border-radius: 15px; border: 1px solid #f0f0f0; transition: 0.3s; }
        .feature-box:hover { transform: translateY(-5px); box-shadow: 0 10px 20px rgba(0,0,0,0.05); }
        .step-num { 
          width: 32px; height: 32px; background: #166070; color: white; 
          border-radius: 50%; display: flex; align-items: center; justify-content: center; font-weight: bold;
        }
        .promo-banner { background: linear-gradient(135deg, #166070 0%, #166070 100%); }
        .promo-icon-bg { 
          position: absolute; right: -10px; bottom: -10px; font-size: 100px; 
          opacity: 0.1; transform: rotate(-15deg); 
        }
        .card-header-gradient { background: linear-gradient(90deg, #166070 0%, #2a91a8 100%); border-radius: 15px 15px 0 0; }
        .main-recharge-card { border-radius: 15px; border: none; background: white; }
        @media (max-width: 767px) {
            .info-side-panel { margin-top: 40px; padding-left: 0; }
            .wallet-amount { font-size: 1.5rem; }
        }
      `}</style>
    </div>
  );
};

export default MobileRecharge;